import * as React from "react";
import { Feature, FeatureProps } from "./feature";

import styled from "@emotion/styled";
import { breakpoints } from "../styles/breakpoints";

const StyledFeatures = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: var(--x-small) auto;

  @media(max-width: ${breakpoints.md}) {
    flex-direction: column;
    align-items: center;
  }

  & > * {
    flex: 0 0 48%;
    margin: var(--macro) 0;
  }
`;

export const Features = ({ features }: { features: FeatureProps[] }) => (
  <StyledFeatures className="container-medium">
    {features.map((f: FeatureProps) => (
      <Feature key={f.title} {...f} />
    ))}
  </StyledFeatures>
);
